export default "__VITE_ASSET__FCdnNfs9__"